export interface Movie {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  summary: string;
  description: string;
  coverImage: string;
  detailImage: string;
  director: string;
  cast: string[];
  duration: string;
  region: string;
  type: "movie" | "tv";
  episodeCount?: number;
  tags: string[];
  updateDate: string;
  isHot: boolean;
  isNew: boolean;
  isFeatured: boolean;
  viewCount: number;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { name: "全部", slug: "all", icon: "ri-movie-line", description: "浏览全部影视内容" },
  { name: "动作片", slug: "action", icon: "ri-fire-line", description: "热血刺激的动作大片" },
  { name: "喜剧片", slug: "comedy", icon: "ri-emotion-happy-line", description: "轻松欢乐的喜剧作品" },
  { name: "科幻片", slug: "scifi", icon: "ri-rocket-line", description: "烧脑震撼的科幻巨制" },
  { name: "爱情片", slug: "romance", icon: "ri-heart-line", description: "浪漫动人的爱情故事" },
  { name: "恐怖片", slug: "horror", icon: "ri-ghost-line", description: "惊险刺激的恐怖体验" },
  { name: "动画片", slug: "animation", icon: "ri-magic-line", description: "精彩纷呈的动画世界" },
  { name: "纪录片", slug: "documentary", icon: "ri-film-line", description: "真实深刻的纪录佳作" },
  { name: "电视剧", slug: "tv-series", icon: "ri-tv-line", description: "精彩剧集一网打尽" },
  { name: "综艺", slug: "variety", icon: "ri-emotion-laugh-line", description: "热门综艺娱乐节目" },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: "星际穿越",
    category: "科幻片",
    categorySlug: "scifi",
    year: 2014,
    rating: 9.4,
    summary: "一组探险者穿越虫洞，为人类寻找新家园的壮丽旅程，诺兰科幻史诗巨作。",
    description: "在不远的未来，地球环境急剧恶化，农作物相继灭绝。前NASA飞行员库珀被选中参与一项秘密计划，与一组科学家穿越虫洞，前往另一个星系寻找适合人类居住的新家园。在这场跨越时空的旅程中，他们面对未知的宇宙奇观，也必须做出改变人类命运的抉择。克里斯托弗·诺兰导演以震撼的视觉效果和深刻的情感内核，呈现了一部关于爱、时间与人类命运的科幻史诗。影片融合了严谨的科学理论与诗意的叙事，汉斯·季默的配乐更是将情感推向高潮。",
    coverImage: "https://readdy.ai/api/search-image?query=Interstellar%20sci-fi%20movie%20poster%20style%20with%20black%20hole%20and%20astronaut%20in%20deep%20space%2C%20cinematic%20lighting%2C%20epic%20composition%2C%20dramatic%20contrast%2C%20minimal%20text%20space%2C%20film%20poster%20aesthetic&width=600&height=800&seq=movie-cover-01&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Interstellar%20movie%20cinematic%20wide%20banner%20with%20spacecraft%20near%20gargantuan%20black%20hole%2C%20nebula%20colors%2C%20epic%20science%20fiction%20atmosphere%2C%20film%20grain%20texture%2C%20dramatic%20lighting%2C%20cinema%20widescreen%20composition&width=1600&height=700&seq=movie-detail-01&orientation=landscape",
    director: "克里斯托弗·诺兰",
    cast: ["马修·麦康纳", "安妮·海瑟薇", "杰西卡·查斯坦", "迈克尔·凯恩"],
    duration: "169分钟",
    region: "美国",
    type: "movie",
    tags: ["科幻", "冒险", "剧情", "太空"],
    updateDate: "2024-06-15",
    isHot: true,
    isNew: false,
    isFeatured: true,
    viewCount: 156890,
  },
  {
    id: 2,
    title: "流浪地球2",
    category: "科幻片",
    categorySlug: "scifi",
    year: 2023,
    rating: 8.3,
    summary: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启长达2500年的流浪之旅。",
    description: "太阳急速老化，持续膨胀，一百年后将吞没地球。面对这场灭顶之灾，人类在地球表面建造出上万台巨大的行星发动机，驱动地球开启长达2500年的宇宙流浪之旅。在这场惊心动魄的旅程中，人类面临月球危机、数字生命计划等多重挑战。吴京、刘德华等实力派演员倾情演绎，郭帆导演再次用震撼的视觉奇观和深刻的人文思考，展现了中国科幻电影的工业实力。影片不仅有着令人窒息的视觉震撼，更蕴含着对文明、责任与牺牲的深沉思考。",
    coverImage: "https://readdy.ai/api/search-image?query=The%20Wandering%20Earth%202%20Chinese%20sci-fi%20movie%20poster%20style%20with%20planet%20earth%20and%20massive%20engines%20in%20space%2C%20epic%20cinematic%20lighting%2C%20dramatic%20orange%20and%20blue%20contrast%2C%20film%20poster%20aesthetic&width=600&height=800&seq=movie-cover-02&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=The%20Wandering%20Earth%202%20cinematic%20wide%20banner%20with%20planet%20earth%20propelled%20by%20giant%20engines%20through%20deep%20space%2C%20nebula%20background%2C%20epic%20sci-fi%20atmosphere%2C%20dramatic%20lighting&width=1600&height=700&seq=movie-detail-02&orientation=landscape",
    director: "郭帆",
    cast: ["吴京", "刘德华", "李雪健", "沙溢"],
    duration: "173分钟",
    region: "中国大陆",
    type: "movie",
    tags: ["科幻", "灾难", "冒险", "国产"],
    updateDate: "2024-07-20",
    isHot: true,
    isNew: false,
    isFeatured: true,
    viewCount: 328900,
  },
  {
    id: 3,
    title: "周处除三害",
    category: "动作片",
    categorySlug: "action",
    year: 2023,
    rating: 8.1,
    summary: "一个黑帮杀手在得知自己身患绝症后，决定在生命最后时光里做一件有意义的事。",
    description: "通缉犯陈桂林发现自己名列台湾三大通缉犯之末，且身患绝症。他决定在生命的最后时光，干掉排在自己前面的两大通缉要犯，成为'周处除三害'的现代传奇。阮经天突破性的表演令人惊艳，他将一个亡命之徒在绝境中寻找人生意义的复杂心理刻画得入木三分。影片融合了黑帮犯罪与禅意哲思，动作场面凌厉干脆，文戏又充满黑色幽默和人性温度，是近年来华语犯罪题材电影的惊喜之作。",
    coverImage: "https://readdy.ai/api/search-image?query=The%20Pig%20the%20Snake%20and%20the%20Pigeon%20Taiwanese%20crime%20action%20movie%20poster%20style%20with%20dark%20moody%20atmosphere%2C%20gritty%20street%20scene%2C%20neon%20lights%2C%20film%20noir%20aesthetic%2C%20minimal%20text%20space&width=600&height=800&seq=movie-cover-03&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Taiwanese%20crime%20action%20film%20cinematic%20wide%20banner%20with%20dark%20rainy%20night%20street%20scene%2C%20neon%20signs%2C%20gritty%20urban%20atmosphere%2C%20film%20noir%20mood%2C%20dramatic%20shadows&width=1600&height=700&seq=movie-detail-03&orientation=landscape",
    director: "黄精甫",
    cast: ["阮经天", "袁富华", "陈以文", "王净"],
    duration: "134分钟",
    region: "中国台湾",
    type: "movie",
    tags: ["犯罪", "动作", "剧情", "黑色幽默"],
    updateDate: "2024-08-01",
    isHot: true,
    isNew: true,
    isFeatured: false,
    viewCount: 89200,
  },
  {
    id: 4,
    title: "你好，李焕英",
    category: "喜剧片",
    categorySlug: "comedy",
    year: 2021,
    rating: 7.9,
    summary: "一个女儿穿越回过去，与年轻时的母亲成为闺蜜，试图改变母亲命运的温情喜剧。",
    description: "2001年的某一天，刚考上大学的贾晓玲遭遇了人生中的一次重大变故。一心想成为母亲骄傲的她，竟意外穿越回1981年，与年轻时的母亲李焕英相遇。两人从陌生到成为闺蜜，晓玲凭借自己的超前思维，试图帮母亲改变命运，让她过上更好的生活。然而一切并没有她想象的那么简单。贾玲导演处女作就交出了一份令人惊艳的答卷，笑中带泪的叙事，真挚动人的母女情感，让无数观众在影院中笑声与泪水交织。",
    coverImage: "https://readdy.ai/api/search-image?query=Hi%20Mom%20Chinese%20comedy%20movie%20poster%20style%20with%20warm%20retro%201980s%20aesthetic%2C%20mother%20and%20daughter%20embracing%2C%20nostalgic%20lighting%2C%20heartwarming%20atmosphere%2C%20film%20poster%20design&width=600&height=800&seq=movie-cover-04&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Chinese%20period%20comedy%20film%20cinematic%20banner%20with%201980s%20factory%20setting%2C%20warm%20nostalgic%20color%20palette%2C%20retro%20Chinese%20industrial%20town%2C%20heartwarming%20atmosphere%2C%20soft%20sunlight&width=1600&height=700&seq=movie-detail-04&orientation=landscape",
    director: "贾玲",
    cast: ["贾玲", "张小斐", "沈腾", "陈赫"],
    duration: "128分钟",
    region: "中国大陆",
    type: "movie",
    tags: ["喜剧", "亲情", "穿越", "感人"],
    updateDate: "2024-06-01",
    isHot: true,
    isNew: false,
    isFeatured: false,
    viewCount: 567200,
  },
  {
    id: 5,
    title: "奥本海默",
    category: "动作片",
    categorySlug: "action",
    year: 2023,
    rating: 8.8,
    summary: "原子弹之父罗伯特·奥本海默的传奇人生，诺兰以IMAX格式呈现的史诗传记巨制。",
    description: "克里斯托弗·诺兰执导的史诗传记片，讲述'原子弹之父'罗伯特·奥本海默的故事。影片聚焦奥本海默在曼哈顿计划中的核心角色，以及他随后因政治立场遭受不公正对待的经历。基里安·墨菲的精湛演技令人叹为观止，诺兰以非线性叙事将科学、政治与人性交织在一起，创造了一部关于天才、道德与命运的深刻思辨。影片的IMAX摄影和实拍特效带来了沉浸式的观影体验，三位一体核试验的场景更是影史经典。",
    coverImage: "https://readdy.ai/api/search-image?query=Oppenheimer%20movie%20poster%20style%20with%20mushroom%20cloud%20and%20dramatic%20black%20and%20white%20contrast%2C%20cinematic%20portrait%20of%20scientist%2C%20film%20noir%20aesthetic%2C%20minimal%20design&width=600&height=800&seq=movie-cover-05&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Oppenheimer%20film%20cinematic%20wide%20banner%20with%20nuclear%20test%20explosion%20in%20desert%2C%20dramatic%20orange%20fireball%2C%20black%20and%20white%20silhouettes%2C%20epic%20biopic%20atmosphere%2C%20imax%20cinematography&width=1600&height=700&seq=movie-detail-05&orientation=landscape",
    director: "克里斯托弗·诺兰",
    cast: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙", "小罗伯特·唐尼"],
    duration: "180分钟",
    region: "美国",
    type: "movie",
    tags: ["传记", "历史", "剧情", "战争"],
    updateDate: "2024-05-10",
    isHot: true,
    isNew: false,
    isFeatured: true,
    viewCount: 234500,
  },
  {
    id: 6,
    title: "铃芽之旅",
    category: "动画片",
    categorySlug: "animation",
    year: 2023,
    rating: 7.7,
    summary: "少女铃芽与闭门师草太一同踏上关闭灾难之门的奇幻冒险旅程。",
    description: "生活在九州乡间的17岁少女铃芽，遇到了一位正在寻找门的旅行青年草太。追随着青年的脚步，铃芽来到山上一片废墟之地，发现了一扇古老的门。仿佛被某种力量吸引，铃芽将手伸向了门——不久之后，日本各地的门开始一扇扇打开。据说，开着的门必须关上，否则灾祸将从门后降临。新海诚导演的最新力作，以精美绝伦的画面和富有想象力的故事，讲述了一段关于成长、记忆与治愈的奇幻冒险。",
    coverImage: "https://readdy.ai/api/search-image?query=Suzume%20Japanese%20anime%20movie%20poster%20style%20with%20girl%20and%20mysterious%20door%20in%20beautiful%20landscape%2C%20stunning%20sky%20colors%2C%20Makoto%20Shinkai%20aesthetic%2C%20dreamy%20atmosphere%2C%20film%20poster&width=600&height=800&seq=movie-cover-06&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Suzume%20anime%20film%20cinematic%20wide%20banner%20with%20beautiful%20Japanese%20coastal%20landscape%2C%20dramatic%20sky%20with%20warm%20sunset%20colors%2C%20anime%20art%20style%2C%20mysterious%20atmosphere%2C%20Makoto%20Shinkai%20aesthetic&width=1600&height=700&seq=movie-detail-06&orientation=landscape",
    director: "新海诚",
    cast: ["原菜乃华", "松村北斗", "深津绘里"],
    duration: "121分钟",
    region: "日本",
    type: "movie",
    tags: ["动画", "奇幻", "冒险", "治愈"],
    updateDate: "2024-07-15",
    isHot: true,
    isNew: true,
    isFeatured: false,
    viewCount: 123400,
  },
  {
    id: 7,
    title: "封神第一部",
    category: "动作片",
    categorySlug: "action",
    year: 2023,
    rating: 7.8,
    summary: "商王殷寿暴虐无道，姬发觉醒踏上封神之路，中国神话史诗巨制。",
    description: "殷商末年，商王殷寿暴虐无道，天怒人怨。西伯侯之子姬发觉醒，召集天下英雄反抗暴政。一场关乎天下苍生命运的大战一触即发。乌尔善导演十年磨一剑，打造了中国神话史诗电影的标杆之作。费翔、李雪健、黄渤等实力派演员阵容强大，影片在视觉特效、服化道和动作场面方面均达到了国产电影的顶级水准。宏大壮阔的史诗叙事，精美的视觉奇观，为观众呈现了一个瑰丽宏大的中国神话世界。",
    coverImage: "https://readdy.ai/api/search-image?query=Creation%20of%20the%20Gods%20Chinese%20mythology%20fantasy%20movie%20poster%20style%20with%20ancient%20Chinese%20warriors%20and%20mythical%20creatures%2C%20epic%20battle%20scene%2C%20dramatic%20gold%20and%20red%20tones%2C%20film%20poster&width=600&height=800&seq=movie-cover-07&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Creation%20of%20the%20Gods%20Chinese%20mythological%20epic%20cinematic%20banner%20with%20ancient%20Chinese%20palace%20and%20vast%20army%2C%20dramatic%20skies%2C%20epic%20fantasy%20atmosphere%2C%20grand%20scale%20composition&width=1600&height=700&seq=movie-detail-07&orientation=landscape",
    director: "乌尔善",
    cast: ["费翔", "李雪健", "黄渤", "于适"],
    duration: "148分钟",
    region: "中国大陆",
    type: "movie",
    tags: ["神话", "奇幻", "动作", "史诗"],
    updateDate: "2024-06-20",
    isHot: false,
    isNew: false,
    isFeatured: true,
    viewCount: 445600,
  },
  {
    id: 8,
    title: "繁花",
    category: "电视剧",
    categorySlug: "tv-series",
    year: 2023,
    rating: 8.7,
    summary: "九十年代的上海，阿宝在时代浪潮中从市井小人物成长为商界风云人物。",
    description: "九十年代的上海，处处是机遇与挑战。阿宝凭借自己的智慧和胆识，在外贸、股票市场中不断打拼，从市井小人物一步步成长为上海滩的风云人物。胡歌领衔主演，王家卫首次执导电视剧，以其独特的视觉美学和叙事风格，将九十年代上海的繁华与喧嚣、人情冷暖展现得淋漓尽致。剧中每个角色都鲜活立体，上海话对白更是增添了浓烈的地域风味，是一部关于时代、梦想与人生的宏大城市史诗。",
    coverImage: "https://readdy.ai/api/search-image?query=Blossoms%20Shanghai%20Chinese%20TV%20drama%20poster%20style%20with%201990s%20Shanghai%20neon%20night%20street%2C%20retro%20aesthetic%2C%20glamorous%20vintage%20atmosphere%2C%20Wong%20Kar%20Wai%20style%2C%20film%20poster&width=600&height=800&seq=movie-cover-08&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cityscape%20at%20night%20with%20neon%20lights%20and%20historic%20buildings%2C%20Wong%20Kar%20Wai%20cinematic%20style%2C%20retro%20Chinese%20urban%20atmosphere%2C%20glamorous%20night%20scene&width=1600&height=700&seq=movie-detail-08&orientation=landscape",
    director: "王家卫",
    cast: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾"],
    duration: "30集",
    region: "中国大陆",
    type: "tv",
    episodeCount: 30,
    tags: ["剧情", "都市", "商战", "年代"],
    updateDate: "2024-07-25",
    isHot: true,
    isNew: true,
    isFeatured: false,
    viewCount: 678900,
  },
  {
    id: 9,
    title: "消失的她",
    category: "恐怖片",
    categorySlug: "horror",
    year: 2023,
    rating: 7.1,
    summary: "妻子在海外度假时神秘失踪，丈夫疯狂寻找却发现了令人窒息的真相。",
    description: "何非的妻子李木子在海外度假时神秘失踪，他疯狂报警寻人。然而当妻子突然出现时，何非却坚称眼前这个陌生女人并非自己的妻子。妻子拿出了身份证明进行自证，夫妻二人似乎都有不可告人的秘密。随着金牌律师陈麦介入调查，更多的谜团慢慢浮现——到底谁在说谎？朱一龙与倪妮的精彩对手戏、层层反转的悬疑叙事，让观众沉浸在紧张刺激的推理过程中，最后的真相令人震惊不已。",
    coverImage: "https://readdy.ai/api/search-image?query=Lost%20in%20the%20Stars%20Chinese%20suspense%20thriller%20movie%20poster%20style%20with%20dark%20moody%20ocean%20night%20scene%2C%20mysterious%20silhouette%2C%20film%20noir%20aesthetic%2C%20dramatic%20contrast&width=600&height=800&seq=movie-cover-09&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Suspenseful%20night%20beach%20scene%20with%20moonlight%20on%20ocean%20waves%2C%20dark%20dramatic%20atmosphere%2C%20mysterious%20tropical%20island%20setting%2C%20thriller%20film%20cinematic%20banner&width=1600&height=700&seq=movie-detail-09&orientation=landscape",
    director: "崔睿 / 刘翔",
    cast: ["朱一龙", "倪妮", "文咏珊", "杜江"],
    duration: "121分钟",
    region: "中国大陆",
    type: "movie",
    tags: ["悬疑", "犯罪", "反转", "惊悚"],
    updateDate: "2024-05-20",
    isHot: false,
    isNew: false,
    isFeatured: false,
    viewCount: 78900,
  },
  {
    id: 10,
    title: "芭比",
    category: "喜剧片",
    categorySlug: "comedy",
    year: 2023,
    rating: 8.1,
    summary: "完美芭比来到真实世界后，开启了一段自我觉醒的奇妙冒险。",
    description: "在芭比乐园里，每一天都是完美的一天。直到有一天，芭比开始思考死亡，她的完美生活出现了裂痕。为了寻找答案，芭比踏上了前往真实世界的旅程，而肯也紧随其后。格蕾塔·葛韦格以独特的女性视角重新诠释了芭比这个经典IP，玛格特·罗比和瑞恩·高斯林的表演令人捧腹又感动。影片在粉色甜美的外表下，包裹着对性别平等、自我认同的深刻思考，是一部既有趣又有深度的佳作。",
    coverImage: "https://readdy.ai/api/search-image?query=Barbie%20movie%20poster%20style%20with%20bright%20pink%20aesthetic%2C%20doll%20in%20fashionable%20outfit%2C%20vibrant%20pop%20art%20style%2C%20fun%20and%20glamorous%20atmosphere%2C%20film%20poster%20design&width=600&height=800&seq=movie-cover-10&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Barbie%20movie%20cinematic%20banner%20with%20bright%20pink%20dream%20house%20and%20plastic%20fantasy%20world%2C%20vibrant%20colorful%20aesthetic%2C%20whimsical%20and%20surreal%20atmosphere%2C%20fun%20cinematography&width=1600&height=700&seq=movie-detail-10&orientation=landscape",
    director: "格蕾塔·葛韦格",
    cast: ["玛格特·罗比", "瑞恩·高斯林", "亚美莉卡·费雷拉"],
    duration: "114分钟",
    region: "美国",
    type: "movie",
    tags: ["喜剧", "奇幻", "女性", "冒险"],
    updateDate: "2024-06-28",
    isHot: false,
    isNew: true,
    isFeatured: false,
    viewCount: 45600,
  },
  {
    id: 11,
    title: "狂飙",
    category: "电视剧",
    categorySlug: "tv-series",
    year: 2023,
    rating: 8.5,
    summary: "一线刑警安欣与黑恶势力长达二十年的生死较量，扫黑除恶的史诗巨制。",
    description: "2000年，一线刑警安欣在执行任务时与鱼贩高启强相识。此后二十年间，安欣与逐渐壮大的黑恶势力展开了殊死较量。从青涩新警到白发苍苍，安欣用一生践行了人民警察的铮铮誓言。张译、张颂文等实力派演员的精彩演绎，让这部反黑刑侦剧成为现象级爆款。剧集不仅有着扣人心弦的案件侦破过程，更深入刻画了人性的复杂与善恶的博弈，是一部令人深思的现实主义力作。",
    coverImage: "https://readdy.ai/api/search-image?query=The%20Knockout%20Chinese%20crime%20drama%20TV%20series%20poster%20style%20with%20police%20officer%20silhouette%20against%20city%20night%20skyline%2C%20gritty%20atmosphere%2C%20dramatic%20contrast&width=600&height=800&seq=movie-cover-11&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Chinese%20urban%20cityscape%20at%20night%20with%20police%20car%20lights%2C%20gritty%20crime%20drama%20atmosphere%2C%20rainy%20street%20scene%2C%20dramatic%20cinematic%20banner%2C%20modern%20Chinese%20city&width=1600&height=700&seq=movie-detail-11&orientation=landscape",
    director: "徐纪周",
    cast: ["张译", "张颂文", "李一桐", "张志坚"],
    duration: "39集",
    region: "中国大陆",
    type: "tv",
    episodeCount: 39,
    tags: ["刑侦", "反黑", "剧情", "悬疑"],
    updateDate: "2024-07-30",
    isHot: true,
    isNew: false,
    isFeatured: true,
    viewCount: 890300,
  },
  {
    id: 12,
    title: "沙丘2",
    category: "科幻片",
    categorySlug: "scifi",
    year: 2024,
    rating: 8.4,
    summary: "保罗·厄崔迪联合弗雷曼人，踏上为父复仇与解放沙丘星球的史诗征程。",
    description: "保罗·厄崔迪与契妮和弗雷曼人联手，踏上为父复仇之路。面对星际间的阴谋和足以摧毁一切的神秘力量，他必须在挚爱与宇宙命运之间做出抉择。丹尼斯·维伦纽瓦以无与伦比的视觉美学，将弗兰克·赫伯特的科幻经典搬上大银幕。提莫西·查拉梅、赞达亚等年轻演员的出色表演，配合汉斯·季默气势磅礴的配乐，创造了一场震撼心灵的视听盛宴。沙漠星球厄拉科斯的壮丽奇观令人叹为观止。",
    coverImage: "https://readdy.ai/api/search-image?query=Dune%20Part%20Two%20sci-fi%20movie%20poster%20style%20with%20desert%20planet%20and%20sandworm%2C%20epic%20cinematic%20composition%2C%20warm%20golden%20sand%20tones%2C%20dramatic%20lighting%2C%20film%20poster&width=600&height=800&seq=movie-cover-12&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Dune%20Part%20Two%20cinematic%20banner%20with%20vast%20desert%20landscape%20and%20massive%20sandworm%2C%20epic%20scale%2C%20warm%20golden%20light%2C%20dust%20storm%20atmosphere%2C%20sci-fi%20desert%20planet&width=1600&height=700&seq=movie-detail-12&orientation=landscape",
    director: "丹尼斯·维伦纽瓦",
    cast: ["提莫西·查拉梅", "赞达亚", "丽贝卡·弗格森", "奥斯汀·巴特勒"],
    duration: "166分钟",
    region: "美国",
    type: "movie",
    tags: ["科幻", "冒险", "史诗", "动作"],
    updateDate: "2024-07-10",
    isHot: true,
    isNew: true,
    isFeatured: true,
    viewCount: 456200,
  },
  {
    id: 13,
    title: "年会不能停",
    category: "喜剧片",
    categorySlug: "comedy",
    year: 2023,
    rating: 8.2,
    summary: "钳工胡建林阴差阳错被调入集团总部，一场啼笑皆非的职场喜剧就此展开。",
    description: "钳工胡建林阴差阳错被调入集团总部，从工厂车间到高档写字楼，他的人生发生了天翻地覆的变化。面对光怪陆离的职场生态，胡建林以自己的真诚和执着，戳破了层层虚伪的面纱。大鹏、白客等喜剧演员的精彩演绎，将当代职场百态展现得淋漓尽致。影片以轻松诙谐的方式讽刺了职场中的官僚主义与形式主义，让观众在捧腹大笑之余产生强烈共鸣，是近年来国产职场喜剧的标杆之作。",
    coverImage: "https://readdy.ai/api/search-image?query=Johnny%20Keep%20Walking%20Chinese%20workplace%20comedy%20movie%20poster%20style%20with%20office%20building%20and%20worker%2C%20bright%20modern%20aesthetic%2C%20humorous%20tone%2C%20corporate%20setting%2C%20film%20poster&width=600&height=800&seq=movie-cover-13&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Modern%20Chinese%20corporate%20office%20building%20interior%20with%20workers%2C%20bright%20clean%20workspace%2C%20humorous%20workplace%20atmosphere%2C%20cinematic%20banner%2C%20modern%20office%20design&width=1600&height=700&seq=movie-detail-13&orientation=landscape",
    director: "董润年",
    cast: ["大鹏", "白客", "庄达菲", "王迅"],
    duration: "135分钟",
    region: "中国大陆",
    type: "movie",
    tags: ["喜剧", "职场", "讽刺", "温情"],
    updateDate: "2024-06-30",
    isHot: false,
    isNew: false,
    isFeatured: false,
    viewCount: 134500,
  },
  {
    id: 14,
    title: "蓝色星球2",
    category: "纪录片",
    categorySlug: "documentary",
    year: 2017,
    rating: 9.8,
    summary: "BBC自然纪录片的巅峰之作，以前所未有的视角展现海洋世界的神奇与壮丽。",
    description: "BBC耗时四年，横跨四大洋，125次远征，用最新的摄影技术捕捉到了前所未见的海洋奇观。从热情洋溢的珊瑚礁到冰冷刺骨的极地海域，从阳光普照的海面到漆黑深邃的海底，蓝色星球2带领观众踏上一场震撼心灵的海洋之旅。大卫·爱登堡爵士的经典旁白配合汉斯·季默的动人配乐，每一个画面都令人叹为观止。这部纪录片不仅是自然之美的赞歌，更是对人类保护海洋生态的深切呼唤。",
    coverImage: "https://readdy.ai/api/search-image?query=Blue%20Planet%20II%20BBC%20documentary%20poster%20style%20with%20deep%20ocean%20marine%20life%2C%20bioluminescent%20creatures%2C%20vibrant%20coral%20reef%2C%20stunning%20underwater%20photography%2C%20documentary%20poster&width=600&height=800&seq=movie-cover-14&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Stunning%20underwater%20coral%20reef%20with%20diverse%20marine%20life%2C%20crystal%20clear%20blue%20ocean%20water%2C%20sunlight%20rays%20through%20water%20surface%2C%20vibrant%20tropical%20fish%2C%20documentary%20cinematic&width=1600&height=700&seq=movie-detail-14&orientation=landscape",
    director: "BBC自然历史部",
    cast: ["大卫·爱登堡（旁白）"],
    duration: "7集",
    region: "英国",
    type: "tv",
    episodeCount: 7,
    tags: ["纪录片", "自然", "海洋", "BBC"],
    updateDate: "2024-05-01",
    isHot: false,
    isNew: false,
    isFeatured: true,
    viewCount: 234100,
  },
  {
    id: 15,
    title: "孤注一掷",
    category: "恐怖片",
    categorySlug: "horror",
    year: 2023,
    rating: 6.9,
    summary: "程序员和模特被高薪诱骗至海外诈骗工厂，生死一线的惊险逃亡。",
    description: "程序员潘生和模特安娜被海外高薪招聘所吸引，却意外落入境外诈骗工厂的陷阱。在封闭的诈骗园区里，他们被迫成为诈骗工具，一边想尽办法逃离，一边见证了诈骗行业的黑暗内幕。张艺兴、金晨等演员突破形象的表演令人印象深刻，影片以极具冲击力的方式揭露了电信诈骗的血腥产业链，引发了广泛的社会讨论。现实题材与惊悚元素的结合，让这部影片具有强烈的警示意义和观赏性。",
    coverImage: "https://readdy.ai/api/search-image?query=No%20More%20Bets%20Chinese%20crime%20thriller%20movie%20poster%20style%20with%20dark%20prison%20cell%20and%20computer%20screens%2C%20gritty%20atmosphere%2C%20red%20alarm%20tones%2C%20film%20poster&width=600&height=800&seq=movie-cover-15&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Dark%20claustrophobic%20computer%20room%20with%20multiple%20monitors%20and%20red%20emergency%20lighting%2C%20underground%20facility%2C%20crime%20thriller%20atmosphere%2C%20dramatic%20cinematic%20banner&width=1600&height=700&seq=movie-detail-15&orientation=landscape",
    director: "申奥",
    cast: ["张艺兴", "金晨", "咏梅", "王传君"],
    duration: "130分钟",
    region: "中国大陆",
    type: "movie",
    tags: ["犯罪", "惊悚", "现实", "社会"],
    updateDate: "2024-04-15",
    isHot: false,
    isNew: false,
    isFeatured: false,
    viewCount: 67800,
  },
  {
    id: 16,
    title: "三体",
    category: "电视剧",
    categorySlug: "tv-series",
    year: 2023,
    rating: 7.9,
    summary: "纳米科学家汪淼卷入神秘事件，揭开外星文明三体世界的惊天秘密。",
    description: "文化大革命期间，天体物理学家叶文洁在军方绝密基地红岸基地向宇宙发出了地球文明的第一声啼鸣。多年后，纳米科学家汪淼被卷入一系列离奇的神秘事件中，一个名为'科学边界'的组织，一款神秘的VR游戏《三体》，以及一个来自遥远星系的文明——三体世界的面纱被缓缓揭开。根据刘慈欣同名科幻巨著改编，剧集以精良的制作还原了原著中的宏大设定和科学想象，为中国科幻剧集树立了新的标杆。",
    coverImage: "https://readdy.ai/api/search-image?query=Three%20Body%20Chinese%20sci-fi%20TV%20series%20poster%20style%20with%20three%20suns%20and%20mysterious%20planet%2C%20cosmic%20scale%2C%20dark%20and%20enigmatic%20atmosphere%2C%20sci-fi%20poster&width=600&height=800&seq=movie-cover-16&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Deep%20space%20with%20three%20suns%20and%20alien%20planet%2C%20cosmic%20scale%2C%20mysterious%20and%20dark%20universe%2C%20sci-fi%20cinematic%20banner%2C%20vast%20galaxy%20background&width=1600&height=700&seq=movie-detail-16&orientation=landscape",
    director: "杨磊",
    cast: ["张鲁一", "于和伟", "陈瑾", "王子文"],
    duration: "30集",
    region: "中国大陆",
    type: "tv",
    episodeCount: 30,
    tags: ["科幻", "悬疑", "外星", "国产"],
    updateDate: "2024-07-05",
    isHot: false,
    isNew: false,
    isFeatured: false,
    viewCount: 345600,
  },
  {
    id: 17,
    title: "灌篮高手",
    category: "动画片",
    categorySlug: "animation",
    year: 2023,
    rating: 8.9,
    summary: "湘北高中篮球队在全国大赛中对决最强对手山王工业，青春的终极之战。",
    description: "湘北高中篮球队在全国大赛中遭遇了最强对手——山王工业高中。宫城良田、三井寿、流川枫、樱木花道、赤木刚宪，这五个性格迥异的少年，为了共同的目标拼尽全力。井上雄彦亲自执导，以全新的CG动画技术将经典漫画搬上大银幕。影片从宫城良田的视角出发，以一场荡气回肠的篮球比赛为载体，讲述了关于成长、友情与梦想的青春故事。当熟悉的主题曲响起，无数观众的青春记忆被瞬间点燃。",
    coverImage: "https://readdy.ai/api/search-image?query=The%20First%20Slam%20Dunk%20Japanese%20anime%20basketball%20movie%20poster%20style%20with%20basketball%20players%20in%20action%2C%20dynamic%20sports%20illustration%2C%20energetic%20composition%2C%20anime%20film%20poster&width=600&height=800&seq=movie-cover-17&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Japanese%20high%20school%20basketball%20court%20with%20players%20in%20intense%20game%20action%2C%20anime%20art%20style%2C%20dramatic%20sports%20lighting%2C%20crowded%20gymnasium%20atmosphere%2C%20dynamic%20composition&width=1600&height=700&seq=movie-detail-17&orientation=landscape",
    director: "井上雄彦",
    cast: ["仲村宗悟", "笠间淳", "神尾晋一郎", "木村昴"],
    duration: "124分钟",
    region: "日本",
    type: "movie",
    tags: ["动画", "体育", "青春", "热血"],
    updateDate: "2024-07-18",
    isHot: true,
    isNew: true,
    isFeatured: false,
    viewCount: 321500,
  },
  {
    id: 18,
    title: "漫长的季节",
    category: "电视剧",
    categorySlug: "tv-series",
    year: 2023,
    rating: 9.4,
    summary: "一个横跨二十年、关于东北小城出租车司机追查碎尸案真相的悬疑故事。",
    description: "东北小城桦林，出租车司机王响遭遇了人生中最漫长的秋天。二十年前的一起碎尸案，如同一道阴影，始终笼罩在他的心头。如今这桩旧案重新浮出水面，王响决定亲自追查真相。范伟以教科书级的演技，塑造了一个倔强、善良又执着的东北男人形象。辛爽导演以极具诗意的镜头语言和巧妙的多线叙事，将悬疑、黑色幽默与东北地域文化完美融合，打造了一部口碑炸裂的国产悬疑神作。",
    coverImage: "https://readdy.ai/api/search-image?query=The%20Long%20Season%20Chinese%20mystery%20drama%20TV%20series%20poster%20style%20with%20autumn%20northeast%20China%20landscape%2C%20rusty%20industrial%20town%2C%20nostalgic%20golden%20light%2C%20film%20poster&width=600&height=800&seq=movie-cover-18&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Northeast%20China%20autumn%20industrial%20town%20with%20golden%20leaves%20and%20old%20factory%20buildings%2C%20nostalgic%20atmosphere%2C%20warm%20sunset%20light%2C%20poetic%20cinematic%20banner&width=1600&height=700&seq=movie-detail-18&orientation=landscape",
    director: "辛爽",
    cast: ["范伟", "秦昊", "陈明昊", "李庚希"],
    duration: "12集",
    region: "中国大陆",
    type: "tv",
    episodeCount: 12,
    tags: ["悬疑", "剧情", "犯罪", "东北"],
    updateDate: "2024-06-25",
    isHot: true,
    isNew: false,
    isFeatured: true,
    viewCount: 567800,
  },
  {
    id: 19,
    title: "过往人生",
    category: "爱情片",
    categorySlug: "romance",
    year: 2023,
    rating: 7.8,
    summary: "青梅竹马的韩国男女，二十年后在纽约重逢，一场关于缘分与选择的温柔故事。",
    description: "诺拉和海成是韩国首尔的青梅竹马，12岁时因诺拉一家移民而分离。二十年后，两人在纽约重逢，面对各自截然不同的人生轨迹，他们需要在过去和现在之间做出选择。席琳·宋导演的处女作以极其细腻的笔触，描绘了一段跨越时空的深情。格蕾塔·李和刘台午的表演克制而动人，影片以东方含蓄的情感表达，探讨了因缘、身份与人生的多重可能。这是一部让人在平静中感受到巨大情感力量的电影。",
    coverImage: "https://readdy.ai/api/search-image?query=Past%20Lives%20romantic%20drama%20movie%20poster%20style%20with%20couple%20walking%20in%20New%20York%20street%20at%20dusk%2C%20tender%20atmosphere%2C%20warm%20golden%20light%2C%20film%20poster&width=600&height=800&seq=movie-cover-19&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=New%20York%20City%20street%20at%20golden%20hour%20sunset%20with%20couple%20silhouette%2C%20romantic%20atmosphere%2C%20warm%20glowing%20light%2C%20cinematic%20banner%2C%20tender%20mood&width=1600&height=700&seq=movie-detail-19&orientation=landscape",
    director: "席琳·宋",
    cast: ["格蕾塔·李", "刘台午", "约翰·马加罗"],
    duration: "106分钟",
    region: "美国",
    type: "movie",
    tags: ["爱情", "剧情", "文艺", "温情"],
    updateDate: "2024-04-20",
    isHot: false,
    isNew: false,
    isFeatured: false,
    viewCount: 23400,
  },
  {
    id: 20,
    title: "蜘蛛侠：纵横宇宙",
    category: "动画片",
    categorySlug: "animation",
    year: 2023,
    rating: 8.6,
    summary: "迈尔斯穿越多元宇宙，与蜘蛛侠联盟共同对抗强大宿命对手的视觉盛宴。",
    description: "重返蜘蛛侠宇宙的迈尔斯·莫拉莱斯，遇到了前所未有的挑战。一个名为'斑点'的全新反派威胁着多元宇宙的安全，而来自不同维度的蜘蛛侠联盟也聚集到了一起。迈尔斯必须重新定义'英雄'的含义，才能保护好自己最爱的人。这部续集在视觉风格上更加大胆创新，融合了水彩、拼贴、手绘等多种艺术形式，每一帧都是一幅惊艳的艺术品。精彩纷呈的多元宇宙冒险配合深刻的情感内核，让这部动画电影成为年度必看之作。",
    coverImage: "https://readdy.ai/api/search-image?query=Spider%20Man%20Across%20the%20Spider%20Verse%20animated%20movie%20poster%20style%20with%20multiple%20spider%20heroes%2C%20vibrant%20comic%20book%20art%2C%20colorful%20graffiti%20style%2C%20dynamic%20composition&width=600&height=800&seq=movie-cover-20&orientation=portrait",
    detailImage: "https://readdy.ai/api/search-image?query=Futuristic%20New%20York%20city%20skyline%20with%20spider%20heroes%20swinging%2C%20vibrant%20comic%20book%20art%20style%2C%20multicolor%20neon%20aesthetic%2C%20dynamic%20cinematic%20banner%2C%20graffiti%20art&width=1600&height=700&seq=movie-detail-20&orientation=landscape",
    director: "乔伊姆·多斯·桑托斯",
    cast: ["沙梅克·摩尔", "海莉·斯坦菲尔德", "奥斯卡·伊萨克"],
    duration: "140分钟",
    region: "美国",
    type: "movie",
    tags: ["动画", "超级英雄", "多元宇宙", "动作"],
    updateDate: "2024-07-22",
    isHot: true,
    isNew: true,
    isFeatured: false,
    viewCount: 287600,
  },
];

export function getMoviesByCategory(slug: string): Movie[] {
  if (slug === "all") return movies;
  return movies.filter((m) => m.categorySlug === slug);
}

export function getMovieById(id: number): Movie | undefined {
  return movies.find((m) => m.id === id);
}

export function getHotMovies(): Movie[] {
  return movies.filter((m) => m.isHot);
}

export function getNewMovies(): Movie[] {
  return movies.filter((m) => m.isNew);
}

export function getFeaturedMovies(): Movie[] {
  return movies.filter((m) => m.isFeatured);
}

export function getRelatedMovies(movie: Movie, count: number = 5): Movie[] {
  return movies
    .filter((m) => m.id !== movie.id && (m.categorySlug === movie.categorySlug || m.tags.some((t) => movie.tags.includes(t))))
    .slice(0, count);
}